import { render, staticRenderFns } from "./BadgeGallery.vue?vue&type=template&id=602f27a4&scoped=true"
import script from "./BadgeGallery.vue?vue&type=script&lang=js"
export * from "./BadgeGallery.vue?vue&type=script&lang=js"
import style0 from "./BadgeGallery.vue?vue&type=style&index=0&id=602f27a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602f27a4",
  null
  
)

export default component.exports